// Reconstructed from the supplied production build; original component names were unavailable.
import { EyeIcon, React } from "../vendor/runtime.js";
const ProductCard = ({ product: a, onView: n, ImageUrl: i, featuredProducts: l }) => {
  const [c, u] = React.useState(false);
  return (
    <div
      className={
        "relative group w-full h-[450px] bg-white backdrop-blur-lg rounded-3xl p-4 shadow-2xl border border-slate-200 hover:scale-[1.02] transition-all duration-500 ease-out overflow-hidden flex flex-col"
      }
      onMouseEnter={() => u(true)}
      onMouseLeave={() => u(false)}
    >
      <div
        className={
          "absolute inset-0 bg-gradient-to-r from-indigo-500/5 via-blue-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        }
      />
      <div className={"absolute top-3 left-3 z-10 flex gap-1 flex-wrap"}>
        <span
          className={
            "bg-gradient-to-r from-indigo-500 to-blue-500 text-white text-xs font-bold py-1 px-2.5 rounded-full shadow-lg"
          }
        >
          {a.category}
        </span>
        <span
          className={
            "bg-gradient-to-r from-purple-500 to-pink-500 text-white text-xs font-bold py-1 px-2.5 rounded-full shadow-lg"
          }
        >
          {a.language}
        </span>
      </div>
      <div className={"relative mb-4 group/image flex-shrink-0"}>
        <div className={"w-full h-48 bg-white rounded-xl  overflow-hidden"}>
          <img
            src={i + a.image}
            alt={a.title + " by code bro final year projects"}
            className={
              "w-full h-full object-contain transition-transform duration-700 group-hover/image:scale-110"
            }
          />
        </div>
      </div>
      <div className={"relative z-10 flex-1 flex flex-col justify-between"}>
        <div className={"flex-1"}>
          <div className={"mb-2"}>
            <h3 className={"text-slate-900 text-[15px] font-bold leading-tight line-clamp-2"}>
              {a.title}
            </h3>
          </div>
          <div className={"mb-3"}>
            <p className={"text-slate-600 text-[10px] line-clamp-2 leading-relaxed"}>
              {a.description}
            </p>
          </div>
        </div>
        <div className={"flex-shrink-0"}>
          <div className={"flex items-center space-x-2 mb-3"}>
            <span className={"text-xl font-bold text-slate-900"}>
              {"₹"}
              {Number(a.amount).toFixed(0)}
            </span>
            <span className={"text-sm text-slate-500 line-through"}>
              {"₹"}
              {Number(a.amount * 2).toFixed(0)}
            </span>
            <span
              className={"bg-orange-500 text-white text-xs font-bold py-0.5 px-1.5 rounded-full"}
            >
              {"50% OFF"}
            </span>
          </div>
          <div className={"flex items-center space-x-2 mb-3"}>
            <div className={"w-1.5 h-1.5 rounded-full bg-green-400"} />
            <span className={"text-xs font-medium text-green-600"}>{"Available Now"}</span>
          </div>
          <div className={"flex"}>
            <button
              onClick={() => n(a.id)}
              className={
                "w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-2 px-4 rounded-xl font-semibold hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-lg flex items-center justify-center space-x-2 text-sm"
              }
            >
              <EyeIcon className={"w-4 h-4"} />
              <span>{"View Details"}</span>
            </button>
          </div>
        </div>
      </div>
      <div className={"absolute inset-0 overflow-hidden pointer-events-none"}>
        {[...Array(4)].map((m, f) => (
          <div
            key={f}
            className={`absolute w-1 h-1 bg-indigo-400/30 rounded-full transition-all duration-1000 ${c ? "animate-pulse" : ""}`}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${f * 0.2}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
};
export { ProductCard };
